class UpsellProducts {
  constructor(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.basePriceCents = parseInt(container.dataset.basePrice, 10);

    this.productForm = document.getElementById(`product-form-${this.sectionId}`);
    this.productFormEl = this.productForm?.closest('product-form');
    this.submitBtn = this.productFormEl?.querySelector('[type="submit"]');
    this.priceContainer = document.getElementById(`price-${this.sectionId}`);
    this.submitPriceEl = document.getElementById(`submit_price-${this.sectionId}`);

    this._bindEvents();
  }

  _bindEvents() {
    this.container.querySelectorAll('.upsell-item__checkbox').forEach((cb) => {
      cb.addEventListener('change', () => this._updateTotalPrice());
    });

    this.container.querySelectorAll('.upsell-item__select').forEach((sel) => {
      sel.addEventListener('change', (e) => this._onVariantChange(e));
    });

    if (this.productForm) {
      this.productForm.addEventListener('submit', (e) => this._onFormSubmit(e), { capture: true });
    }

  }

  _getCheckedItems() {
    return [...this.container.querySelectorAll('.upsell-item__checkbox:checked')];
  }

  _updateTotalPrice() {
    const upsellTotal = this._getCheckedItems().reduce(
      (sum, cb) => sum + parseInt(cb.dataset.price, 10),
      0
    );
    const total = this.basePriceCents + upsellTotal;
    const formatted = formatMoney(total, window.moneyFormat);

    // Update price display — covers both regular and sale price states
    this.priceContainer?.querySelectorAll('.price-item--regular, .price-item--sale').forEach((el) => {
      // Skip the compare-at (strikethrough) price element inside .price__sale
      if (!el.closest('.price__sale') || el.classList.contains('price-item--sale')) {
        el.textContent = formatted;
      }
    });

    // Update button price
    if (this.submitPriceEl) this.submitPriceEl.textContent = formatted;
  }

  _onVariantChange(event) {
    const select = event.target;
    const item = select.closest('.upsell-item');
    let variants;
    try {
      variants = JSON.parse(select.dataset.variants);
    } catch {
      return;
    }
    const variant = variants.find((v) => String(v.id) === String(select.value));
    if (!variant) return;

    // Update checkbox attributes
    const checkbox = item.querySelector('.upsell-item__checkbox');
    checkbox.dataset.price = variant.price;
    checkbox.dataset.variantId = variant.id;

    // Update price label
    const priceLabel = item.querySelector('.upsell-item__price');
    if (priceLabel) {
      priceLabel.textContent = `+${formatMoney(variant.price, window.moneyFormat)}`;
    }

    // Swap thumbnail if variant has an image (use 80px sized URL to avoid fetching full-res)
    const img = item.querySelector('.upsell-item__image');
    if (img && variant.featured_image) {
      img.src = variant.featured_image.src.replace(/\.(jpg|jpeg|gif|png|webp)(\?.*)?$/i, '_80x80.$1');
    }

    // Recalculate total if this item is checked
    if (checkbox.checked) this._updateTotalPrice();
  }

  async _onFormSubmit(evt) {
    if (this.submitBtn?.getAttribute('aria-disabled') === 'true') return;
    const checkedItems = this._getCheckedItems();
    if (checkedItems.length === 0) return; // No upsells — let product-form.js handle normally

    evt.preventDefault();
    evt.stopImmediatePropagation();

    this._clearError();

    // Replicate product-form.js loading state
    this.submitBtn?.setAttribute('aria-disabled', 'true');
    this.submitBtn?.classList.add('loading');
    this.submitBtn?.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

    const mainVariantId = parseInt(
      this.productForm.querySelector('[name="id"]').value,
      10
    );

    const items = [
      { id: mainVariantId, quantity: 1 },
      ...checkedItems.map((cb) => ({
        id: parseInt(cb.dataset.variantId, 10),
        quantity: 1,
      })),
    ];

    const cart =
      document.querySelector('cart-drawer') ||
      document.querySelector('cart-notification');

    const sectionsToRender = cart ? cart.getSectionsToRender().map((s) => s.id) : [];
    if (cart) cart.setActiveElement(document.activeElement);

    try {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        items,
        sections: sectionsToRender,
        sections_url: window.location.pathname,
      });

      const response = await fetch(window.routes.cart_add_url, config).then((r) =>
        r.json()
      );

      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: mainVariantId,
          errors: response.description,
          message: response.message,
        });
        this._showError(response.description || response.message);
        return;
      }

      if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        productVariantId: mainVariantId,
      });
      cart.renderContents(response);

      // Uncheck upsells and reset price after successful add
      this._resetUpsells();

      if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    } catch (e) {
      console.error('[upsell-products] cart add error:', e);
    } finally {
      this.submitBtn?.classList.remove('loading');
      this.submitBtn?.removeAttribute('aria-disabled');
      this.submitBtn?.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
    }
  }

  _showError(message) {
    const wrapper = this.productFormEl?.querySelector(
      '.product-form__error-message-wrapper'
    );
    const msgEl = wrapper?.querySelector('.product-form__error-message');
    if (!wrapper || !msgEl) return;
    wrapper.removeAttribute('hidden');
    msgEl.textContent = message;
  }

  _resetUpsells() {
    this.container.querySelectorAll('.upsell-item__checkbox:checked').forEach((cb) => {
      cb.checked = false;
    });
    this._updateTotalPrice();
  }

  _clearError() {
    const wrapper = this.productFormEl?.querySelector(
      '.product-form__error-message-wrapper'
    );
    if (wrapper) wrapper.toggleAttribute('hidden', true);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-upsell-products]').forEach((container) => {
    new UpsellProducts(container);
  });
});
